/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { subscribeAsync } from './DataActionExtension.g';
import { IAAA_Response } from './DataServiceEntities.g';
/**
 * SubscribeData Input Action
 */
export class SubscribeDataInput implements Msdyn365.IActionInput {
    public email: string;
    constructor(email: string) {
        this.email = email;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `DEFAULT`;
    public getCacheObjectType = () => 'TODO';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new SubscribeDataInput('');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function subscribeAction(input: SubscribeDataInput, ctx: Msdyn365.IActionContext): Promise<IAAA_Response> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<ISubscribeDataData[]>('/get/example/id/1', 'get');
    let subscribeResponse: IAAA_Response = { Error: false, Message: '' };
    try {
        subscribeResponse = await subscribeAsync({ callerContext: ctx }, input.email);
    } catch (error) {
        console.log(error);
    }
    return subscribeResponse;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IAAA_Response>>subscribeAction,
    // TODO: Give your data action a unique id
    id: 'SubscribeData',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
